import Vue from 'vue'
import router from './router.js'
import App from './App.vue'

import './assets/less/main.less'
import _group from './config/group';

Vue.prototype.$group = _group;

import _api from './config/api';
Vue.prototype.$api = _api;


function initVueApp() {
  // 防止重复初始化（重要！）
  if (window.__VUE_APP_MOUNTED__) return;
  
  const el = document.getElementById('vueapp');
  if (!el) {
    console.warn('#vueapp not found');
    return;
  }

  // 标记已挂载
  window.__VUE_APP_MOUNTED__ = true;

  new Vue({
    router,
    el: '#vueapp',
    render: h => h(App)
  });
}

// 检查当前是否处于预渲染状态
function isPrerendering() {
  return document.visibilityState === 'prerender' || 
         document.prerendering === true; // 新标准（部分浏览器支持）
}

// 启动逻辑：只有当 DOM 就绪 **且** 页面可见时才初始化
function tryInit() {
  // 必须同时满足：DOM 已解析 + 页面非预渲染
  if (
    document.readyState !== 'loading' && !isPrerendering()
  ) {
    initVueApp();
  }
}

// 监听两个关键事件
if (document.readyState === 'loading') {
  // 等 DOM 解析完成
  document.addEventListener('DOMContentLoaded', tryInit);
} else {
  // DOM 已就绪，但仍需检查 visibility
  tryInit();
}

// 监听从预渲染切换到可见状态
document.addEventListener('visibilitychange', tryInit);

// 兜底：如果长时间未触发（极端情况），1秒后强制尝试（可选）
setTimeout(tryInit, 1000);